<div class="item-details mb-5 mt-3">
    <div class="route-summary px-3">
        <table aria-describedby="Table for Task Details" class="task-details">
            <tr>
                <th scope="row">RouteName</th>
                <td>{{ routeDetails?.route_label }}</td>
                <th scope="row">Route State</th>
                <td>{{ routeDetails?.route_state }}</td>
                <th scope="row">Route Begin</th>
                <td>{{ routeDetails?.route_time_window?.begin | dateFormat : 'datetime'}}
                </td>
                <th scope="row">Route End</th>
                <td>{{ routeDetails?.route_time_window?.end | dateFormat : 'datetime'}}
                </td>
            </tr>
        </table>
        <hr style="margin: 0px;" />
    </div>

    <!-- Optimization action buttons -->
    <div class="optimization-actions d-flex justify-content-end gap-2 px-3 mt-3">
        <button class="pn-button pn-button-primary pn-button-sm" [disabled]="isRouteStateDisabled" (click)="openOptimizationConfirmation('RPS Optimization')">
            RPS Optimization
        </button>
        <button class="pn-button pn-button-primary pn-button-sm" [disabled]="isSlotInDisabled" (click)="openOptimizationConfirmation('Slot in')">
            Slot in
        </button>
    </div>

    <div class="prime-table mt-3">
        <p-table [columns]="routeOptimizationColumns" styleClass="p-datatable-striped p-datatable-sm p-datatable-tbody"
            [resizableColumns]="true" [scrollable]="true" scrollHeight="400px" 
            [value]="routeOptimizationDetails">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th style="text-align: left;min-width:120px !important;" [id]="col">
                            {{ col.header }}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td style="text-align: left;" *ngFor="let col of columns">
                        <span> {{ rowData[col.field]
                            }}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [colSpan]="routeOptimizationColumns.length">
                        <div class="text-center">
                            No Records found.
                        </div>
                    </td>
                </tr>
            </ng-template>

        </p-table>

    </div>
</div>

<!-- Confirmation Dialog for Optimization -->
@if(showConfirmationDialog) {
  <p-dialog [(visible)]="showConfirmationDialog" [modal]="true"
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" [style]="{ width: '30vw' }" [draggable]="false"
    [resizable]="false"  [appendTo]="'body'" >
    <ng-template pTemplate="header">
        <div class="pn-dialog-header">
            <p class="pn-heading-title mb-0">Route {{optimizationTitle}}</p>
        </div>
    </ng-template>
    <div class="confirmation-dialog-content px-5 py-5 text-center">
      <h5 class="mb-4">Are you sure you want to {{optimizationTitle}} the route - <b> {{ routeDetails?.route_label }}</b>?</h5>
      <div class="confirmation-dialog-actions">
        <p-select [options]="optimizationApproaches" appendTo="body" [(ngModel)]="selectedOptimizationApproach" placeholder="Select approach"
          class="mb-2" [style]="{ width: '50%' }"></p-select>
      </div>
    </div>
    <ng-template pTemplate="footer">
        <button class="pn-button pn-button-primary pn-button-md me-1" [disabled]="!selectedOptimizationApproach" (click)="handleOptimizationConfirmation()">Confirm</button>
        <button class="pn-button pn-button-tertiary pn-button-md me-2" (click)="showConfirmationDialog = false;">Cancel</button>
    </ng-template>
  </p-dialog>
}

<!-- RPS Optimization Dialog -->
@if(showRPSOptimizationDialog) {
  <p-dialog [(visible)]="showRPSOptimizationDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '70vw' }" [style]="{ width: '60vw' }" [draggable]="false"
    [resizable]="false"  [appendTo]="'body'" >
     <ng-template pTemplate="header">
        <div class="pn-dialog-header">
            <p class="pn-heading-title mb-0">RPS Optimization</p>
            <p class="pn-heading-subtitle mb-0">Route - {{ routeDetails?.route_label }} <span [ngStyle]="routeDetails.route_state | kpiRouteState">({{routeDetails?.route_state}})</span></p>
        </div>
    </ng-template>
    <app-optimised-sequence #optimisedSequence 
      [routesDetails]="routeDetails" 
      [selectedOptimizationApproach]="selectedOptimizationApproach"
      (closeRPSOptimizationDialog)="showRPSOptimizationDialog = false"
      (optimizationAccepted)="getRouteOptimization()"
    >
    </app-optimised-sequence>
    <ng-template pTemplate="footer">
        <ng-container *ngTemplateOutlet="optimisedSequence.optimisedSequenceFooter"></ng-container>
    </ng-template>
  </p-dialog>
}